import { Search } from '@mui/icons-material'
import {
    Box,
    Button,
    InputAdornment,
    Stack,
    TextField,
    Typography,
} from '@mui/material'
import { GetCompanyClientsQuery } from '__generated__/graphql'
import { useState } from 'react'
import { getPxAsRem } from 'shared/utils'
import { StyledCard } from './styled'
import ClientPermissionsTable from './table'

export interface PermissionsUsersProps {
    data: GetCompanyClientsQuery | undefined
    refetch: () => void
    onAddUser?: () => void
}

const PermissionsUsers: React.FC<PermissionsUsersProps> = ({
    data,
    refetch,
    onAddUser,
}) => {
    const header = (
        <Box sx={{ width: '100%' }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                }}
            >
                <Typography variant="h4">Users</Typography>
                <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={onAddUser}
                >
                    Add User
                </Button>
            </Box>
        </Box>
    )

    const [searchValue, setSearchValue] = useState('')

    const search = (
        <Box sx={{ width: getPxAsRem(32, 64) }}>
            <TextField
                onChange={(e) => setSearchValue(e?.target?.value ?? '')}
                variant="standard"
                value={searchValue}
                placeholder="Search Name"
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                    ),
                }}
            />
        </Box>
    )
    return (
        <StyledCard>
            <Stack direction="column" spacing={2}>
                {header}
                {search}
                <ClientPermissionsTable
                    data={data}
                    searchInput={searchValue}
                    refetch={refetch}
                />
            </Stack>
        </StyledCard>
    )
}

export default PermissionsUsers
